import type { FC } from 'react'
import type { TopicCardCTAType } from '../atoms/TopicCardCTA'
import { TopicCardCTA } from '../atoms/TopicCardCTA'
import { ContentBlockWrapper } from '../molecules/ContentBlockWrapper'

export type TopicsBlockProps = {
	topics: TopicCardCTAType[]
}

export const TopicsBlock: FC<TopicsBlockProps> = ({ topics }) => {
	return (
		<ContentBlockWrapper blockTypes={['component']} gridClassName="gap-y-xl">
			{topics.map((topic, index) => (
				<div
					key={topic.href || index}
					className="col-span-full layout-narrow:tablet-l:col-span-full layout-wide:tablet-l:col-span-4"
				>
					<TopicCardCTA card={topic} />
				</div>
			))}
		</ContentBlockWrapper>
	)
}
